import { useMemo } from "react"
import { t } from "@lingui/macro"

import TenantCard from "./TenantCard"

import { ITenantListProps } from "src/views/contracts/pages/details/types/contract-detail"
import { StyledContractDetails } from "src/views/contracts/pages/details/styled"

export const TenantsList = ({
    tenants = [],
    onSimulateTenant,
}: ITenantListProps) => {
    const displayTenants = useMemo(() => {
        return tenants.length > 0 ? tenants : []
    }, [tenants])

    return (
        <StyledContractDetails.SectionWrapper>
            <StyledContractDetails.SectionTitle>{t`contract-details.tenant`}</StyledContractDetails.SectionTitle>
            <StyledContractDetails.Tenant.List>
                {displayTenants.map((tenant, index) => (
                    <TenantCard
                        key={tenant.tenant_id ?? index}
                        tenant={tenant}
                        onSimulateTenant={onSimulateTenant}
                    />
                ))}
            </StyledContractDetails.Tenant.List>
        </StyledContractDetails.SectionWrapper>
    )
}

export default TenantsList
